<template >
    <div class="company-contact">
        <!-- <div class="company-name-en mb-4">English name</div> -->
        <p class="company-description">{{ companyData.description }}</p>

            <b-row align-h="between">
            <b-col class="company-media" md="5">
                <div>البريد الالكترونى</div>
                <a :href="'mailto:'+companyData.email">{{ companyData.email }}</a>
            </b-col>
            <b-col class="company-media" md="5">
                <div class="d-flex align-items-center ">
                    <span>
                        العنوان
                    </span>
                    <a target="_blank" :href="getGoogleMapsLink(companyData.latitude, companyData.longitude)"><vue-feather class="mx-2" size="16" stroke="#0765F1" type="map"></vue-feather></a>
                </div>
                <a href="#">{{ companyData.address }}</a>
            </b-col>
        </b-row>

        <b-row align-h="between">

            <b-col class="company-media" md="5" v-if="isAuthenticated" >
                <div>تاريخ التأسيس</div>
                <a href="#">{{ companyData.established_at }}</a>

            </b-col>
            <b-col class="company-media" md="5">
                <div>الموقع الألكترونى</div>
                <a :href="companyData.website" target="_blank">{{ companyData.website }}</a>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: { companyData:{
      type: Object,
      default: () => {},

    },
},
computed: {
    isAuthenticated() {
      // Check if the token exists in localStorage
      return !!localStorage.getItem("token");
    },
  },
methods: {
    getGoogleMapsLink(latitude, longitude) {
      return `https://www.google.com/maps?q=${latitude},${longitude}`;
    },
  },
}
</script>
<style lang="">

</style>
